import request from '@/utils/request';
import { subscriptionsEndpoint } from '@/constants/urls';

const getSubscriptions = () => request({
  url: subscriptionsEndpoint(''),
  method: 'GET',
});

const subscribe = (event) => request({
  url: subscriptionsEndpoint(event),
  method: 'POST',
});

const unsubscribe = (event) => request({
  url: subscriptionsEndpoint(event),
  method: 'DELETE',
});

const SubscriptionsService = {
  getSubscriptions,
  subscribe,
  unsubscribe,
};

export default SubscriptionsService;
